import "@kne/button-group/dist/index.css";

import {ConfirmButton, ConfirmLink, ConfirmText, withConfirm} from '@kne/button-group';

export {ConfirmButton, ConfirmLink, ConfirmText, withConfirm};

export default ConfirmButton;
